const normalizeTime = (time, splitBy = ":") => {
	if (!time?.includes(":")) {
		return "";
	}

	const meridian = time.match(/(am|pm)/gi)?.[0] || "";
	if (meridian) {
		time = time.replace(meridian, "").trim();
	}
	const [hours, minutes, seconds = "0"] = time.split(splitBy);
	return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}:${seconds.padStart(2, "0")} ${meridian}`.trim();
};

const removeMeridian = (time) => time.replace(/(am|pm)/gi, "").trim();

const getDateFormat = (date, args) => {
	const { locale = "en-US", options = { year: "numeric", month: "short", day: "numeric" } } = args || {};
	return new Date(date).toLocaleDateString(locale, options);
};

const getFormattedTime = (date, args) => {
	const { locale = "en-US", options = { hour: "2-digit", minute: "2-digit" } } = args;
	return new Date(date).toLocaleTimeString(locale, options);
};

export { normalizeTime, removeMeridian, getDateFormat, getFormattedTime };
